
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none"}},[_c('path',{attrs:{"fill":"#2B2B2A","fill-rule":"evenodd","d":"M17.85 7.564a1 1 0 00-1.414-1.414L12 10.586 7.564 6.15A1 1 0 006.15 7.564L10.586 12 6.15 16.436a1 1 0 001.414 1.414L12 13.414l4.436 4.436a1 1 0 001.414-1.414L13.414 12l4.436-4.436z","clip-rule":"evenodd"}})])
      }
    
      }
    